export const ConversionOutputStreamDestinationList = [
  'email',
  'webhook',
  'meta-ads',
  'google-ads-data-manager',
  'microsoft-ads-conversion',
  'openai-ads',
] as const;

export type ConversionOutputStreamDestination =
  (typeof ConversionOutputStreamDestinationList)[number];
